export default {
  apiKey: 'AIzaSyA8_vo4yO_Unm6cc0kAVqPhBQ4TCynkWqA',
  authDomain: 'whattowatch-5c593.firebaseapp.com',
  databaseURL: 'https://whattowatch-5c593.firebaseio.com',
  projectId: 'whattowatch-5c593',
  storageBucket: '',
  messagingSenderId: '324528554296',
  appId: '1:324528554296:web:d369ddc531189b61db41cd'
}